import React, { useEffect } from "react";
import AdminLayout from "./Common/AdminLayout";
import AdminHome from "./AdminHome";
import "../../asset/new/css/admin-modern.css";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Dashboard | Admin";
  }, []);

  return (
    <AdminLayout
      title="Admin Dashboard"
      subtitle="Welcome back! Here's an overview of your portal"
      breadcrumbs={[
        { label: "Admin", active: false },
        { label: "Dashboard", active: true }
      ]}
    >
      <AdminHome />
    </AdminLayout>
  );
};

export default Dashboard;
